import * as React from "react";
import PropTypes from "prop-types";

class TDrawerContent extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        style: PropTypes.object,
    };

    static defaultProps = {
        style: {},
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        const styles = {
            innerModal: {
                overflowY: "auto",
                position: "absolute",
                top: 66,
                bottom: 0,
                left: 0,
                right: 0,
                // background: 'green'
                ...this.props.style,
            },
        };

        return (
            <div
                className="DrawerContent"
                style={styles.innerModal}
            >
                {this.props.children}
            </div>
        );
    }
}

export default TDrawerContent;
